import axios from 'axios'

const baseURL = 'https://backend-prod.acertapromotora.com.br/'

const api = axios.create({ baseURL })

export default api
